export function chunk(array, size)
{
    if (!array.length) {
        throw new Error("Invalid array provided.");
    }

    if (!size) {
        throw new Error("Invalid size value provided.");
    }

    let result = [];


    for (let i = 0; i < array.length; i += size) {
        result.push(array.slice(i, i + size));
    }


    return result;
}